import React from 'react';
import { IoCalendar, IoArrowRedoSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import News from '../../models/news.model';
import { returnLimitedWords } from '../../utils/common.utils';
import moment from 'moment';
import { lang } from '../../config/app.config';
import Logo from '../../assets/images/lg-s.png';
var adbs = require("ad-bs-converter");

interface blogprops {
  news: News,
}

const BlogCard: React.FC<blogprops> = (props) => {

  const { news } = props;

  let date = moment(news.created_at).format('yyyy/MM/DD');
  let convertedDate = adbs.ad2bs(date);
  let langKey = lang == 'np' ? 'ne' : 'en';

  let npObj = news?.translations.find(obj => {
    return obj.locale === 'np';
  })
  let enObj = news?.translations.find(obj => {
    return obj.locale === 'en';
  })

  let title = lang === 'np' ? npObj?.title : enObj?.title;
  if (!title || title === '') {
    title = npObj?.title ?? enObj?.title;
  }

  return (
    <div className="ecn-blog-card">
      <div className="ecn-blog-card--img">
        <img src={news?.image || Logo} alt="" />
        <div className="overlay">
          <Link to={'/' + lang + "/news/" + news.slug}><IoArrowRedoSharp className="icon" /></Link>
          <div className="date">
            <IoCalendar /><span>{`${convertedDate[langKey]?.day} ${convertedDate[langKey]?.strMonth} ${convertedDate[langKey]?.year} `}</span>
          </div>
        </div>
      </div>

      <div className="ecn-blog-card--details">
        <Link to={'/' + lang + "/news/" + news.slug}>
          <h3
            className="text-15-primary mb-05"
          // title={news.translations.length ? returnLimitedWords(news.translations[0]?.title, 60) || '' : ''}
          >
            {title ? returnLimitedWords(title, 60) || '' : ''}
          </h3>
        </Link>
        <p className="m-0">
          {
            news.excerpt ?
              returnLimitedWords(news.excerpt, 150)
              : ''
          }
        </p>
      </div>
    </div>
  );
}

export default BlogCard;